import http from "../http/http-config";
import { CoverNote } from "../models/coverNote";

export default new class CoverNoteService {
    getCoverNote(onDate, productId, securityGroup, correlationInformation, userName, userToken, tokenType): Promise<CoverNote[]> {
        return http.get<CoverNote[]>("CoverNote", {
            params: {
                productId,
                securityGroup,
                onDate,
                correlationInformation,
                userName,
                userToken,
                tokenType
            }
        }).then(response => response.data)
    }
}